const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function dateToUTC (date) {
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000)
}
export function getMonthNameShort (date) {
  return monthsShort[date.getMonth()]
}
export function getUTCStandardDatetime (date) {
  const utc = dateToUTC(date)
  return utc.getDate() + ' ' + getMonthNameShort(utc) + ' ' + utc.getFullYear() + ' ' + getIntString(utc.getHours()) + ':' + getIntString(utc.getMinutes()) + ':' + getIntString(utc.getSeconds()) + ' UTC'
}
function getIntString (i) {
  if (i < 0) { return '00' }
  return i < 10 ? '0' + i : i
}
export function secondsToHHMMSS (sec) {
  const secNum = parseInt((sec || 0), 10) // don't forget the second param
  let hours = Math.floor(secNum / 3600)
  let minutes = Math.floor((secNum - (hours * 3600)) / 60)
  let seconds = secNum - (hours * 3600) - (minutes * 60)

  if (hours < 10) { hours = '0' + hours }
  if (minutes < 10) { minutes = '0' + minutes }
  if (seconds < 10) { seconds = '0' + seconds }
  return hours + ':' + minutes + ':' + seconds
}

export function HHMMSSToSeconds (str) {
  if(!str || !str.length) return 0
  const [hours, minutes, seconds] = str.split(':').map(s => parseFloat(s))
  return (hours * 3600) + (minutes * 60) + seconds
}
